import { Box } from '@mui/material';
import React from 'react';
import AssessmentResultOverview from '../assessment-result-overview/AssessmentResultOverview';
import AssessmentScore from '../assessment-scenarios/AssessmentScore';
import AssessmentScenarios from '../assessment-score/AssessmentScenarios';
import { Assessment as IAssessment, SimulationStatus } from '../types';

export interface AssessmentProps {
  assessment: IAssessment;
  simulationStatus: SimulationStatus;
}

const Assessment = ({ assessment, simulationStatus }: AssessmentProps) => (
  <Box display={{ xs: 'flex', md: 'grid' }} flexDirection="column" gridTemplateColumns="repeat(4, 1fr)" gap={2} mb={4}>
    <AssessmentResultOverview
      {...assessment}
      inProgress={simulationStatus === SimulationStatus.Ongoing}
      sx={{ gridColumn: '1/4' }}
    />
    <AssessmentScore {...assessment} />
    <AssessmentScenarios
      inProgress={simulationStatus === SimulationStatus.Ongoing}
      scenarios={assessment.scenarios}
      sx={{ gridColumn: '1/5' }}
    />
  </Box>
);

export default Assessment;
